import { usePermission } from '@fs/zion-permissions'
import { i18n } from '@fs/zion-locale'
import { geoData } from '@fs/zion-config'

const arabicCountryCodes = [
  'AE', // United Arab Emirates
  'BH', // Bahrain
  'DZ', // Algeria
  'EG', // Egypt
  'IL', // Israel
  'IQ', // Iraq
  'JO', // Jordan
  'KW', // Kuwait
  'LB', // Lebanon
  'LY', // Libya
  'MA', // Morocco
  'OM', // Oman
  'PS', // Palestine
  'QA', // Qatar
  'SA', // Saudi Arabia
  'SD', // Sudan
  'SY', // Syria
  'TN', // Tunisia
  'YE', // Yemen
]
export default function useShowArabicExperience() {
  const [isMember] = usePermission('FtMemberUiPermission')
  const isArabicLanguage = i18n.language === 'ar'
  const isArabicCountry = arabicCountryCodes.includes(geoData?.country)

  if (!isMember && (isArabicLanguage || isArabicCountry)) {
    return true
  }
  return false
}
